import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { getInflowDonutOption } from "../chartConfigs";
import { formatTableCellValue } from "../utils";
const OverviewInflowChart = ({ data }) => {
  const chartData = useMemo(
    () =>
      (data || [])
        .map((d) => ({
          name: d.Description,
          value: Math.abs(d.Actuals),
          originalValue: d.Actuals,
        }))
        .sort((a, b) => b.value - a.value),
    [data],
  );

  const option = useMemo(() => getInflowDonutOption(chartData), [chartData]);
  const colors = [
    "#854F0B",
    "#EF9F27",
    "#FAC775",
    "#FAEEDA",
    "#B8860B",
    "#C47A05",
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
      <ReactECharts
        option={option}
        style={{ height: 260 }}
        notMerge
        lazyUpdate
      />
      <div className="space-y-2">
        {chartData.slice(0, 5).map((item, i) => (
          <div
            key={item.name}
            className="flex items-center justify-between text-sm"
          >
            <div className="flex items-center gap-2">
              <span
                className="h-2.5 w-2.5 rounded-sm"
                style={{ backgroundColor: colors[i % colors.length] }}
              />
              <span className="text-slate-600 font-medium truncate">
                {item.name}
              </span>
            </div>
            <span className="font-mono font-semibold text-slate-700">
              {formatTableCellValue(item.originalValue)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OverviewInflowChart;
